import { render, staticRenderFns } from "./contactShop.vue?vue&type=template&id=2d8084ea&scoped=true"
import script from "./contactShop.vue?vue&type=script&lang=js"
export * from "./contactShop.vue?vue&type=script&lang=js"
import style0 from "./contactShop.vue?vue&type=style&index=0&id=2d8084ea&prod&lang=scss&scoped=true"
import style1 from "./contactShop.vue?vue&type=style&index=1&id=2d8084ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8084ea",
  null
  
)

export default component.exports